import script from "./CoachingSession.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoachingSession.vue?vue&type=script&lang=ts&setup=true"

import "./CoachingSession.vue?vue&type=style&index=0&id=c7e816b4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e816b4"]])

export default __exports__